module.exports = __webpack_public_path__ + "img/scroll.2699a195.svg";